import { Box, BoxProps, Flex, Heading, IconButton, Text } from '@chakra-ui/react'
import React from 'react'
import { RiFolderWarningLine } from 'react-icons/ri'
import { IAlteracoes } from '../../pages/DescritivoCargos/utils/ajustes'
import { PropInvalida } from '../../Utils/Helper'

export interface ItensTabelaProps{
  descricaoDicionario?: Array<Record<string, string[]>>
}

export interface TabelaItensProps extends BoxProps {
  tituloTabela: string
  itensTabela?: ItensTabelaProps[]
  descricaoSimples?: string
  descricaoSimplesArray?: string[]
  isTabelaDescricaoSimples?: boolean
  alteracaoDocumento?: boolean
  acaoModalAlteracaoDocumento?: () => void
  statusAjustes?: IAlteracoes
}

export const TabelaItens: React.FC<TabelaItensProps> = ({ tituloTabela, itensTabela, descricaoSimples, isTabelaDescricaoSimples, alteracaoDocumento, acaoModalAlteracaoDocumento, statusAjustes, descricaoSimplesArray, ...rest }) => {
    type Linha = { titulo: string, itens: string[] }

    function normalizarDescricao(item: ItensTabelaProps): Linha[] {
      const d = item.descricaoDicionario ?? []
      return d.flatMap((rec) =>
        Object.entries(rec).map(([titulo, itens]) => ({
          titulo,
          itens: itens ?? []
        }))
      )
    }
    console.log('Titulo', tituloTabela)
    console.log(statusAjustes, 'status ajustes tabela')

    function verificaAlteracaoNivel(itemAtual: string, nivel: string): boolean {
      if (statusAjustes) {
        if (statusAjustes?.alteracoesDicionario?.[nivel]?.some(item => item === itemAtual)) {
          return true
        }
      }

      return false
    }
    function verificaAlteracao(itemAtual: string): boolean {
      if (statusAjustes) {
        if (statusAjustes?.alteracoes?.some(item => item === itemAtual)) {
          return true
        }
        if (statusAjustes?.alteracao === itemAtual) {
          return true
        }
      }

      return false
    }
    function inclusoesDoNivel(nivel: string): string[] {
      return statusAjustes?.alteracoesInclusaoDicionario?.[nivel] ?? []
    }
    function inclusoesSimples(): string[] {
      return statusAjustes?.alteracoesInclusao ?? []
    }
    return (
        <Box pt={'4'} pb={'4'} {...rest}>
            <Flex w={'1380px'} border={'2px solid var(--chakra-colors-gray-400)'} flexDirection={'column'} >
                <Box bg={'gray.100'} display={'flex'} justifyContent={'center'} alignItems={'center'} h={'42px'} w={'100%'} >
                    <Heading size={'md'}>{tituloTabela}</Heading>
                    {alteracaoDocumento === true && (
                      <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
                        <IconButton
                          aria-label='Visualizar'
                          icon={ <RiFolderWarningLine color='red' size={26} />}
                          variant="ghost"
                          bg={'transparent'}
                          _hover={{ bg: 'transparent' }}
                          _active={{ bg: 'transparent' }}
                          _focus={{ boxShadow: 'none' }}
                          title="Visualizar pedidos"
                          onClick={acaoModalAlteracaoDocumento}
                        />
                        {statusAjustes && statusAjustes?.quantidadeAlteracoes > 1 && (
                          <Text color="red" fontWeight="bold" fontSize="sm">
                          Alterações ( {statusAjustes?.quantidadeAlteracoes} )
                        </Text>
                        )}
                        {statusAjustes && statusAjustes?.quantidadeAlteracoes === 1 && (
                          <Text color="red" fontWeight="bold" fontSize="sm">
                          Alteração ( {statusAjustes?.quantidadeAlteracoes} )
                        </Text>
                        )}

                        {!statusAjustes && (
                        <Text color="red" fontWeight="bold" fontSize="sm">
                          Alteração
                        </Text>)
                        }
                      </Box>
                    )}
                </Box>
                {!isTabelaDescricaoSimples
                  ? (
                <Box display="flex" flexDirection="column" w="100%">
                {itensTabela?.map((item, index) => {
                  const linhas = normalizarDescricao(item)

                  return (
                    <Box key={index} w="100%">
                        {linhas.map((linha, idx) => (
                        <Box
                            key={idx}
                            display="flex"
                            w="100%"
                            borderBottom="1px solid var(--chakra-colors-gray-400)"
                        >
                            {/* ESQUERDA: nível */}
                            <Box
                            w="112px"
                            bg="gray.200"
                            display="flex"
                            alignItems="center"
                            p={4}
                            flexShrink={0}
                            >
                            <Heading ml="1rem" size="md" fontWeight="normal">
                                {linha.titulo.replaceAll('_', ' ')}
                            </Heading>
                            </Box>

                            {/* DIREITA: itens */}
                            <Box w="100%" bg="white" p={4}>
                            {linha.itens.filter(Boolean).map((txt, i) => (
                                <Text key={i} color={verificaAlteracaoNivel(txt, linha.titulo) ? 'red' : 'black'} size="md">
                                {txt}
                                </Text>
                            ))}
                            {inclusoesDoNivel(linha.titulo)
                              .filter(Boolean)
                              .filter(txt => !linha.itens.includes(txt))
                              .map((txt, i) => (
                                <Text key={`inc-${i}`} color="blue.500" size="md">
                                {txt}
                                </Text>
                              ))}
                            </Box>
                        </Box>
                        ))}
                    </Box>
                  )
                })}
                </Box>
                    )
                  : (
                   <Box display="flex" flexDirection="column" w="100%">
                    {!!descricaoSimplesArray?.length &&
                      descricaoSimplesArray.map((item, index) => (
                        <Box key={`${index}-${tituloTabela}`} w="100%" bg="white" p={4}>
                          <Text size="md" color={verificaAlteracao(item) ? 'red' : 'black'}>
                            {item}
                          </Text>
                        </Box>
                      ))
                    }
                    {inclusoesSimples()
                      .filter(Boolean)
                      .filter(item => !(descricaoSimplesArray ?? []).includes(item))
                      .map((item, index) => (
                        <Box key={`inc-${index}-${tituloTabela}`} w="100%" bg="white" p={4}>
                          <Text size="md" color="blue.500">
                            {item}
                          </Text>
                        </Box>
                      ))
                    }
                     {!PropInvalida(descricaoSimples) && (

                       <Box w="100%" bg="white" p={4}>
                       <Text size="md" color={verificaAlteracao(descricaoSimples ?? '') ? 'red' : 'black'}>
                       {descricaoSimples ?? 'Passe a descrição nos atributos do componente'}
                       </Text>
                       </Box>
                     )}
                   </Box>
                    )}
                </Flex>
            </Box>
    )
}
